import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { deleteAssignedUsers } from "api/services/user-service";

export const useDeleteAssignedUsers = () => {
    const { callAPI, loading } = useWorkspaceApiCall(deleteAssignedUsers, 'deleteAssignedUsers.success', 'deleteAssignedUsers.error');

    const deleteAssignedUsersMethod = useCallback(async (userId: string) => {
        return await callAPI({ userId });
    }, [callAPI]);
    
    return { deleteAssignedUsers: deleteAssignedUsersMethod, deletingAssignedUsers: loading };
}